import { render } from "./callFollowUpReportV2.vue?vue&type=template&id=9330f418&scoped=true"
import script from "./callFollowUpReportV2.vue?vue&type=script&lang=js"
export * from "./callFollowUpReportV2.vue?vue&type=script&lang=js"

import "./callFollowUpReportV2.vue?vue&type=style&index=0&id=9330f418&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9330f418"]])

export default __exports__